import { useState, useEffect } from "react";
import {
  Button,
  Container,
  Card,
  CardHeader,
  CardContent,
  CardActions,
  FormControlLabel,
  Grid,
  Loading,
  Switch,
  TextField,
} from "../../../components";
import { notification, MarcasService } from "../../../services";
import { InputErros, PermisoesHelper } from "../../../helpers";
import { responseErros } from "../../../utils";
import marcaValidator from "./middlewares/marca.validator";

const AddMarcas = ({ id, handleCloseDialog }) => {
  const [loading, setLoading] = useState(false);
  const [marca, setMarca] = useState({
    ativado: true,
  });
  const [inputErro, setInputErro] = useState([]);
  const inputErros = new InputErros(inputErro, setInputErro);
  const marcasService = new MarcasService();
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("marcas-visualizar");

  useEffect(() => {
    buscaMarca();
  }, []);

  const buscaMarca = async () => {
    if (!id) return;
    setLoading(true);
    const { data } = await marcasService.getById(id);
    setMarca(data);
    setLoading(false);
  };

  const handleInputChange = (e) => {
    e.persist();
    setInputErro([]);
    setMarca((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async () => {
    setLoading(true);
    marcaValidator
      .validate(marca, { abortEarly: false })
      .then(async () => {
        if (id) {
          const response = await marcasService.atualizar(id, marca);
          setLoading(false);
          if (!response.isAxiosError) {
            notification.alteracaoSucesso();
            handleCloseDialog();
          } else {
            responseErros(response);
          }
        } else {
          const response = await marcasService.cadastrar(marca);
          setLoading(false);
          if (!response.isAxiosError) {
            notification.cadastroSucesso();
            handleCloseDialog();
          } else {
            responseErros(response);
          }
        }
      })
      .catch((err) => {
        setLoading(false);
        inputErros.set(err);
      });
  };

  return (
    <Container>
      <Card className="p-3">
        <CardHeader
          title={marca?.id ? "Editar marca" : "Cadastrar marca"}
          action={
            <FormControlLabel
              control={
                <Switch
                  checked={marca?.ativado || false}
                  onChange={() =>
                    setMarca((prevState) => ({
                      ...prevState,
                      ativado: !prevState?.ativado,
                    }))
                  }
                  name="ativado"
                  color="primary"
                />
              }
              label={marca?.ativado ? "Ativado" : "Desativado"}
            />
          }
        />
        <CardContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                id="nome"
                name="nome"
                label="Nome"
                variant="outlined"
                margin="normal"
                value={marca?.nome || ""}
                onChange={handleInputChange}
                fullWidth
                required
                error={inputErros.get("nome")}
              />
            </Grid>
          </Grid>
        </CardContent>
        <CardActions>
          <Button color="primary" variant="contained" onClick={handleSubmit}>
            <i
              className="ph-fill ph-check-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Salvar
          </Button>
          <Button
            color="padrao"
            variant="contained"
            onClick={handleCloseDialog}
          >
            <i
              className="ph-fill ph-x-circle"
              style={{ fontSize: 22, marginRight: 10 }}
            ></i>
            Fechar
          </Button>
        </CardActions>
      </Card>
      <Loading loading={loading} />
    </Container>
  );
};

export default AddMarcas;
